<template>
  <div>hello</div>
</template>

<script>
export default {
  name: 'Settings',
}
</script>
